import { NgModule, LOCALE_ID } from '@angular/core'; //LOCALE_ID
import { ProductionCostComponent } from './production-cost.component';
import { CommonModule, DatePipe } from '@angular/common';
import { CostAccordionComponent } from './cost-accordion/cost-accordion.component';
import { BankAccountCreateModalComponent, CommentPopupModule, CreditCardCreateModalComponent, DropdownModule } from '@ops/components';
import { VersionMenuModule } from 'legacy/shared/components/src/lib/version-menu/version-menu.module';
import { SearchBarModule } from 'legacy/shared/components/src/lib/search-bar/search-bar.module';
import { BigNumberPipe } from 'legacy/shared/components/src/lib/pipes/big-number.pipe';
import { OrderModule } from 'ngx-order-pipe';
import { FormsModule } from '@angular/forms';
import {  OpsSelectComponent } from '@ops/storybook';
import { TranslateModule } from '@ngx-translate/core';
import { OpsCustomCurrencyModalComponent } from '@ops/storybook';
import { NumericInputComponent } from '@ops/components';

@NgModule({
  imports: [
    CommonModule,
    CostAccordionComponent,
    BigNumberPipe,
    VersionMenuModule,
    DropdownModule,
    CommentPopupModule,
    SearchBarModule,
    OrderModule,
    FormsModule,
    OpsSelectComponent,
    BankAccountCreateModalComponent,
    CreditCardCreateModalComponent,
    TranslateModule,
    OpsCustomCurrencyModalComponent,
    NumericInputComponent,
  ],
  declarations: [ProductionCostComponent],
  exports: [
    CommentPopupModule,
    CostAccordionComponent,
    ProductionCostComponent,
  ],
  providers: [DatePipe],
})
export class ProductionCostModule {}
